// This file is generated. Do not modify it.
// See: packages/pulse/scripts/transpile-variables.ts
export const numbers = {
  sizeComponent: {
    base: 40,
    large: 48,
    xlarge: 64,
    small: 32,
    xsmall: 24,
    xxsmall: 16,
  },
  sizeIcon: {
    base: 24,
    large: 32,
    xlarge: 40,
    small: 16,
    xsmall: 12,
  },
  spacing: {
    xxlarge: 40,
    large: 24,
    base: 16,
    small: 8,
    xsmall: 4,
    xxsmall: 2,
    xlarge: 32,
    medium: 12,
  },
  corner: {
    xlarge: 16,
    large: 12,
    base: 8,
    small: 4,
    xsmall: 2,
    round: 100,
  },
  cornerIcon: {
    base: 8,
    small: 5.5,
    xsmall: 4,
    large: 10.5,
    xlarge: 13.5,
  },
};

export type Numbers = typeof numbers;
